import React, { useCallback, useEffect, useState } from 'react';

import queryString from 'query-string';
import { useHistory, useLocation } from 'react-router-dom';

import CreatePassword from '../../components/createPassword/CreatePassword';
import useBlocRef from '../../utils/useBlocRef.hook';

export default ({ isInvite }) => {
  const blocRef = useBlocRef('createPasswordBloc');
  const [termsCheck, setTermsCheck] = useState(false);
  const [buttonError, setButtonError] = useState(null);

  const { search } = useLocation();
  const { token } = queryString.parse(search);
  const history = useHistory();
  const validate = useCallback(async () => {
    if (!token) {
      history.push('/login');
      return;
    }

    try {
      if (isInvite) {
        // validate invite token
        await blocRef.current.validateInviteToken(token);
      } else {
        // validate forgot password token
        await blocRef.current.validateForgotToken(token);
      }
    } catch (e) {
      history.push('/login');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, isInvite]);

  useEffect(() => {
    validate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const termsCheckSub = blocRef.current.termsCheck$.subscribe(setTermsCheck);
    const buttonErrorSub = blocRef.current.buttonError$.subscribe(setButtonError);

    return () => {
      termsCheckSub.unsubscribe();
      buttonErrorSub.unsubscribe();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleTermsCheckChange = (target, state) => blocRef.current.updateTermsCheck(target, state);

  const handleSubmit = async ({ newPassword }) => {
    if (isInvite) {
      const isValid = blocRef.current.validateRequiredField();
      if (!isValid) return;
    }

    try {
      await blocRef.current.setForgotPassword(token, newPassword, isInvite);

      if (isInvite) {
        // invitation
        history.push('/auth-success?action=invitation');
      } else {
        // reset forgot password
        history.push('/auth-success?action=reset');
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log('Error Resetting Password:', error);
    }
  };

  return <CreatePassword onSubmit={handleSubmit} isInvite={isInvite} termsCheck={termsCheck} onTermsCheckChange={handleTermsCheckChange} buttonError={buttonError} />;
};
